import { render } from "./Topic.vue?vue&type=template&id=48cf9053&scoped=true"
import script from "./Topic.vue?vue&type=script&lang=ts"
export * from "./Topic.vue?vue&type=script&lang=ts"

import "./Topic.vue?vue&type=style&index=0&id=48cf9053&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-48cf9053"

export default script